// extracted by mini-css-extract-plugin
export default {"message":"MessageDialog_message__R1pp+","actions":"MessageDialog_actions__fH5GM"};